<ngx-slick-carousel class="carousel wrapper" [config]="slideConfigForMainBanner">
	<div class="home-banner" *ngFor="let i of bannerData" ngxSlickItem>
		<div class="banner-item">
			<img class="slide-img" [src]="i?.imgSrc" style="width: 100%;">
			<div class="banner-content text-left">
				<span class="subtitle">MyLifeWell for Business: </span>
				<span class="subtitle">All-in-One Wellness Platform</span>
				<h2 class="banner-title text-capitalize">
					<span>Increase employee</span> <span>wellbeing, reduce</span> <span>stress and grow</span>
					<span>your
						business with</span> <span> MylifeWell for Business.</span>
				</h2>
				<a class="btn started-btn btn-purple" href="https://business.mylifewell.com/" target="_blank">
					Learn More
				</a>
			</div>
		</div>
	</div>
</ngx-slick-carousel>
<div class="main-sec text-center">
	<div class="container">
		<div class="main-heading">
			<h2 class="main-title">Live your life well</h2>
			<p class="main-desc">
				MyLifeWell is your one stop shop for leading a health and wellness lifestyle.
			</p>
		</div>
		<div class="row">
			<div class="col-md-2 col-lg-4 col-xl-3">
				<div class="live-card">
					<a href="https://business.mylifewell.com/" target="_blank">
						<img src="assets/images/live-img01.jpg" alt="mylifewell">
						<span class="live-title text-uppercase">
							<!-- Free on-demand classes -->
							Corporate Wellness Program
						</span>
					</a>
				</div>
			</div>
			<!-- <div class="col-md-2 col-lg-4 col-xl-3">
				<div class="live-card" (click)="goToSection('vendor/registration')">
					<img src="assets/images/yoga.jpg" alt="mylifewell">
					<span class="live-title text-uppercase">
						Coach Signup
					</span>
				</div>
			</div> -->
			<div class="col-md-2 col-lg-4 col-xl-3">
				<div class="live-card"
					(click)="goToLink('https://business.mylifewell.com/holistic-wellness-marketplace/')">
					<img src="assets/images/yoga.jpg" alt="mylifewell">
					<span class="live-title text-uppercase">
						Coach Signup
					</span>
				</div>
			</div>
			<div class="col-md-2 col-lg-4 col-xl-3">
				<div class="live-card" (click)="goToSection('livewell/onetoone')">
					<img src="assets/images/live-img03.jpg" alt="mylifewell">
					<span class="live-title text-uppercase">
						Personal Coaching
					</span>
				</div>
			</div>
			<!-- <div class="col-md-2 col-lg-4 col-xl-3">
				<div class="live-card" (click)="goToSection('shopwell')">
					<img src="assets/images/live-img04.jpg" alt="">
					<span class="live-title text-uppercase">
						Wellness Products
					</span>
				</div>
			</div> -->
			<div class="col-md-2 col-lg-4 col-xl-3">
				<div class="live-card">
					<img src="assets/images/live-img04.jpg" alt="">
					<span class="live-title text-uppercase">
						Wellness lifestyle
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
<div class="main-sec text-center" style="background: #f8f8f8;">
	<div class="container">
		<div class="main-heading">
			<h2 class="main-title">Popular Classes</h2>
			<p class="main-desc">
				From yoga and meditation to fitness and healthy eating, explore hundreds of on-demand classes and
				programs for
				free.
			</p>
		</div>
		<div class="popular-slider">
			<ngx-slick-carousel class="carousel" [config]="slideConfigForPopularClasses">
				<div class="card-wrap recc-card " ngxSlickItem (click)="goToUrl(data.gotoUrl)"
					*ngFor="let data of popularClassData">
					<div class="card popular-card text-left backgroundNone">
						<div class="clip-img card-variant">
							<img [src]="data.thumbUrl" class="card-img-top" alt="card image" />
							<span class="clip-icn"><img src="assets/images/video-icon.png" alt="video-icon" /></span>
						</div>
						<div class="card-body">
							<div class="schedule d-flex justify-content-between">
								<p class="card-text">
									{{data.title}}
								</p>
							</div>
						</div>
					</div>
				</div>
			</ngx-slick-carousel>
		</div>
	</div>
</div>
<div class="home-app-sec text-center">
	<img class="app-banner" src="assets/images/app-banner-img.jpg" alt="">
	<div class="container app-content">
		<h2 class="app-title">
			Go Premium
		</h2>
		<p class="app-desc">
			MyLifeWell: The first all-in-one health and wellness app.
			With 2000+ on-demand classes, 5000+ 3D exercise videos, guided meditations, custom workouts, fitness
			challenges,
			nutrition tracking and social groups, the MyLifeWell app offers all the tools that you need to lead a
			healthy
			lifestyle!
		</p>
		<a routerLink="/membership/app" class="btn started-btn">
			Claim your 7 days free membership
			<img src="assets/images/double-right-arrow.png" alt="">
		</a>
	</div>
</div>

<div class="main-sec latest-blog-sec">
	<div class="container">
		<div class="main-heading text-center">
			<h2 class="main-title">Latest From the Blog </h2>
			<p class="main-desc">
				Looking for more inspiration? Subscribe to our newsletter below!
			</p>
		</div>
		<div class="row">
			<div class="col-md-2 col-lg-4"
				(click)="goToUrl('https://www.mylifewell.com/blogs/six-spring-vegetables-and-what-to-do-with-them/');">
				<div class="blog-card">
					<figure>
						<img src="https://www.mylifewell.com/blogs/wp-content/uploads/2021/04/image7.jpg"
							alt="mylifewelly">
					</figure>
					<div class="blog-content">
						<h4 class="blog-title">
							Six spring vegetables (& what to do with them)
						</h4>
						<div class="blog-schedule">
							<span><em><img src="assets/images/calender-gray-icn.png" alt=""></em> Jan 1, 2021</span>
							<span><em><img src="assets/images/watch-gray-icn.png" alt=""></em> 4 min read</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-2 col-lg-4"
				(click)="goToUrl('https://www.mylifewell.com/blogs/learnwell-5-common-worries-about-downward-dog/')">
				<div class="blog-card">
					<figure>
						<img src="https://www.mylifewell.com/blogs/wp-content/uploads/2021/04/image1.jpg"
							alt="mylifewell">
					</figure>
					<div class="blog-content">
						<h4 class="blog-title">
							Learnwell: 5 common worries about downward dog
						</h4>
						<div class="blog-schedule">
							<span><em><img src="assets/images/calender-gray-icn.png" alt=""></em> Feb 5, 2021</span>
							<span><em><img src="assets/images/watch-gray-icn.png" alt=""></em> 6 min read</span>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-2 col-lg-4"
				(click)="goToUrl('https://www.mylifewell.com/blogs/how-employers-can-help-reduce-zoom-fatigue/')">
				<div class="blog-card">
					<figure>
						<img src="https://www.mylifewell.com/blogs/wp-content/uploads/2021/03/image1.jpg"
							alt="mylifewell blog">
					</figure>
					<div class="blog-content">
						<h4 class="blog-title">
							How employers can help reduce zoom fatigue
						</h4>
						<div class="blog-schedule">
							<span><em><img src="assets/images/calender-gray-icn.png" alt=""></em> Jan 5, 2021</span>
							<span><em><img src="assets/images/watch-gray-icn.png" alt=""></em> 3 min read</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- home-insta-wrap class removed from below DIV -->
<div class="">
	<div class="main-sec home-lifewell">
		<div class="container">
			<div class="main-heading text-center">
				<h2 class="main-title d-flex align-item-md-center justify-content-center"><span class="instalogo"><img
							src="assets/images/insta-logo.png" alt=""></span> #mylifewell_</h2>
			</div>
			<ngx-slick-carousel class="carousel" [config]="slideConfigForBlog">
				<div class="insta-item" *ngFor="let i of instaData" ngxSlickItem (click)="instagramClick(i?.goToUrl)">
					<img [src]="i?.imgSrc">
				</div>
			</ngx-slick-carousel>
		</div>
	</div>
</div>
<div class="enquiry-poup">
	<app-modal-pop-up [responseMessage]="responseMessage" *ngIf="showAlert" (triggerCloseEvent)="triggerCloseEvent()">
	</app-modal-pop-up>
</div>
<app-newsletter-new></app-newsletter-new>